import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import { IRecommendationCardPayload } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCard/RecommendationCard.utils.types';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { ITab } from 'components/common/CustomizedTabs/CustomizedTabs';

export const tabsArrData: ITab<IActiveTab>[] = [
    {
        value: 'cardDetails',
        label: <CardTab title={'Card Details'} />,
    },
    {
        value: 'relatedCards',
        label: <CardTab title={'Associated Activities'} />,
    },
    {
        value: 'auditLogs',
        label: <CardTab title={'Audit Log'} />,
    },
];

export const buildRecommendationCardPayload = (data): IRecommendationCardPayload => {
    return {
        id: data.id,
        projectId: data.project.id,
        contractId: data.contract.id,
        activityId: data.activityId,
        assigneeUserName: data.assignee.value,
        category: data.category.value,
        details: data.details,
        mentionedList: data.mentionedList,
        startDate: data.startDate,
        endDate: data.endDate,
        externalLinks: data.externalLinks,
        status: data.status.name,
        title: data.title,
        relatedCardIds: null,
        type: data.type,
        isImportant: data.isImportant,
        versionId: data.versionId,
    };
};
